import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function Buildings({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#building_icon)">
        <path
          d="M6.88892 14.4444V6.88889C6.88892 6.39822 7.28714 6 7.7778 6H12.6667C13.1574 6 13.5556 6.39822 13.5556 6.88889V14.4444"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.44434 14.4444V3.92177C2.44434 3.56444 2.65767 3.24177 2.98656 3.1031L6.98656 1.41155C7.57234 1.16355 8.22211 1.59377 8.22211 2.23021V3.77777"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.55566 14.4443H14.4446"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.11108 9.11095V8.6665"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3333 9.11095V8.6665"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.11108 11.7779V11.3335"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3333 11.7779V11.3335"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="building_icon">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
